import resolve from '../../../../api-client';
import { CURRENCIES__FETCH } from '../constants';
import { getCurrenciesUrl } from '../../util';

export const currenciesFetch = () =>
  resolve({
    type: CURRENCIES__FETCH,
    url: getCurrenciesUrl(),
  });
